<template>
  <TextField
    v-if="isFieldVisible(name)"
    v-bind="$attrs"
    v-model="address"
    :id="id"
    :name="name"
    :rules="rules"
    :label="label"
    :required="required"
  />
</template>

<script setup lang="ts">
import { useContactCaptureContext } from "@/components/forms/useContactCapture";
import emojiRegex from "emoji-regex";
import { uniqueId } from "underscore";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { string } from "yup";
import TextField from "./TextField.vue";

const emojiPattern = emojiRegex();

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    id?: string;
    name?: string;
    label?: string;
    minLength?: number;
    maxLength?: number;
    required?: boolean;
  }>(),
  {
    label: "Address",
    name: "address",
    autocomplete: "street-address",
  }
);

const id = computed(() => props.id ?? uniqueId("field-"));

const rules = string().test(
  "no-emoji",
  t("form.field.text.invalid.emoji"),
  (value) => !value || !emojiPattern.test(value)
);

const { address, isFieldVisible } = useContactCaptureContext();
</script>
